export const LOGIN='LOGIN'
export const GET_USER_NAME='GET_USER_NAME'
export const USER='USER'
export const GET_USER='GET_USER'
export const LOGOUT_USER='LOGOUT_USER'